import { AUTH_SUCCESS, LOGOUT } from "./GlobalContext";

  
  export default function appReducer(state, action) {
    switch (action.type) {
      case AUTH_SUCCESS:
        return {
          ...state,
          user: action.payload.user,
        };
  
      case LOGOUT:
        return {
          ...state,
          user: null,
        };
  
      default:
        return state;
    }
  }
  